import AWS from "aws-sdk";
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});
const s3 = new AWS.S3();

const currentDate = new Date();
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, "0");
const day = String(currentDate.getDate()).padStart(2, "0");

export const uploadToS3 = (file, folder, HandleProgress) => {
  return new Promise((resolve, reject) => {
    const params = {
      Bucket: process.env.REACT_APP_AWS_S3_BUCKET,
      Key: `${folder}/${year}/${month}/${day}/${file.name}`,
      Body: file,
      ContentType: file.type,
      ACL: "public-read", 
    };

    s3.upload(params)
      .on("httpUploadProgress", (evt) => {
        const percent = Math.round((evt.loaded / evt.total) * 100);
        console.log(`Upload Progress: ${percent}%`);
        HandleProgress(percent);
      })
      .send((err, data) => {
        console.log("he he h e");
        
        if (err) {
          console.log("hi");
          
          reject({ status: false, err });
        } else {
          console.log("hello");

          resolve({
            status: true,
            folder: folder,
            fileName: file.name,
            location: data.Location,
          });
        }
      });
    // s3.upload(params, (err, data) => {
    //   if (err) {
    //     reject(err);
    //   } else {
    //     resolve({
    //       folder: folder,
    //       fileName: file.name,
    //       location: data.Location,
    //     });
    //   }
    // });
  });
};
